import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  width = '100%',
  className = '',
  viewBox = '0 0 289.748 203',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Grupo_4647" data-name="Grupo 4647" transform="translate(-252 -305)">
      <path
        id="plane-solid"
        d="M80.266,32.106H61.155L43.581,1.348A2.678,2.678,0,0,0,41.256,0H30.3a2.674,2.674,0,0,0-2.572,3.41l8.2,28.7h-17.2l-7.224-9.632a2.676,2.676,0,0,0-2.14-1.07H2.679a2.675,2.675,0,0,0-2.6,3.324l5.269,18.08L.084,60.887a2.675,2.675,0,0,0,2.6,3.324H9.366a2.674,2.674,0,0,0,2.14-1.07l7.224-9.632h17.2L27.732,82.2A2.676,2.676,0,0,0,30.3,85.615H41.256a2.677,2.677,0,0,0,2.323-1.348L61.155,53.51H80.266c5.911,0,16.053-4.791,16.053-10.7S86.178,32.106,80.266,32.106Z"
        transform="matrix(0.875, -0.485, 0.485, 0.875, 415.999, 364.083)"
        fill="#5a005a"
        opacity="0.5"
      />
      <path
        id="search-dollar-solid"
        d="M100.613,88.186,80.749,68.326a4.778,4.778,0,0,0-3.387-1.395H74.115a41.429,41.429,0,1,0-7.172,7.17v3.247a4.778,4.778,0,0,0,1.395,3.387L88.2,100.6a4.762,4.762,0,0,0,6.754,0l5.638-5.638a4.8,4.8,0,0,0,.02-6.771ZM41.441,70.117A28.684,28.684,0,1,1,70.129,41.434,28.669,28.669,0,0,1,41.441,70.117Zm5.4-30.389-8.967-2.689A2.6,2.6,0,0,1,36.128,34.5a2.5,2.5,0,0,1,2.351-2.628h5.6a4.774,4.774,0,0,1,2.554.741,1.635,1.635,0,0,0,2.018-.145l2.341-2.233a1.6,1.6,0,0,0-.114-2.419,11.407,11.407,0,0,0-6.249-2.261V22.312a1.593,1.593,0,0,0-1.594-1.594H39.848a1.593,1.593,0,0,0-1.594,1.594v3.211a8.872,8.872,0,0,0-8.5,8.979,9.016,9.016,0,0,0,6.291,8.644l8.967,2.689a2.6,2.6,0,0,1,1.747,2.536A2.5,2.5,0,0,1,44.406,51h-5.6a4.774,4.774,0,0,1-2.554-.741,1.635,1.635,0,0,0-2.018.145l-2.341,2.233a1.6,1.6,0,0,0,.114,2.419,11.407,11.407,0,0,0,6.249,2.261v3.245a1.593,1.593,0,0,0,1.594,1.594h3.188a1.593,1.593,0,0,0,1.594-1.594V57.351a8.871,8.871,0,0,0,8.5-8.979,9.015,9.015,0,0,0-6.293-8.644Z"
        transform="translate(252 305)"
        fill="#5a005a"
        opacity="0.5"
      />
      <path
        id="hotel-solid"
        d="M122.5,14a3.5,3.5,0,0,0,3.5-3.5v-7A3.5,3.5,0,0,0,122.5,0H3.5A3.5,3.5,0,0,0,0,3.5v7A3.5,3.5,0,0,0,3.5,14H7V98H3.5A3.5,3.5,0,0,0,0,101.5v7A3.5,3.5,0,0,0,3.5,112H56V94.5A3.51,3.51,0,0,1,59.5,91h7A3.51,3.51,0,0,1,70,94.5V112h52.5a3.5,3.5,0,0,0,3.5-3.5v-7a3.5,3.5,0,0,0-3.5-3.5H119V14ZM56,23.8A3.011,3.011,0,0,1,58.8,21h8.4A3.011,3.011,0,0,1,70,23.8v8.4A3.011,3.011,0,0,1,67.2,35H58.8A3.011,3.011,0,0,1,56,32.2V23.8Zm0,21A3.011,3.011,0,0,1,58.8,42h8.4A3.011,3.011,0,0,1,70,44.8v8.4A3.011,3.011,0,0,1,67.2,56H58.8A3.011,3.011,0,0,1,56,53.2V44.8Zm-28-21A3.011,3.011,0,0,1,30.8,21h8.4A3.011,3.011,0,0,1,42,23.8v8.4A3.011,3.011,0,0,1,39.2,35H30.8A3.011,3.011,0,0,1,28,32.2V23.8ZM39.2,56H30.8A3.011,3.011,0,0,1,28,53.2V44.8A3.011,3.011,0,0,1,30.8,42h8.4A3.011,3.011,0,0,1,42,44.8v8.4A3.011,3.011,0,0,1,39.2,56ZM42,84a21,21,0,0,1,42,0ZM98,53.2A3.011,3.011,0,0,1,95.2,56H86.8A3.011,3.011,0,0,1,84,53.2V44.8A3.011,3.011,0,0,1,86.8,42h8.4A3.011,3.011,0,0,1,98,44.8v8.4Zm0-21A3.011,3.011,0,0,1,95.2,35H86.8A3.011,3.011,0,0,1,84,32.2V23.8A3.011,3.011,0,0,1,86.8,21h8.4A3.011,3.011,0,0,1,98,23.8Z"
        transform="translate(345 396)"
        fill="#5a005a"
      />
      <path
        id="suitcase-rolling-solid"
        d="M24.5,11.667H3.5a3.5,3.5,0,0,0-3.5,3.5V31.5A3.5,3.5,0,0,0,3.5,35H4.667v1.167a1.166,1.166,0,0,0,1.167,1.167H8.167a1.166,1.166,0,0,0,1.167-1.167V35h9.333v1.167a1.166,1.166,0,0,0,1.167,1.167h2.333a1.166,1.166,0,0,0,1.167-1.167V35H24.5A3.5,3.5,0,0,0,28,31.5V15.167A3.5,3.5,0,0,0,24.5,11.667Zm-1.167,15.75A.583.583,0,0,1,22.75,28H5.25a.583.583,0,0,1-.583-.583V26.25a.583.583,0,0,1,.583-.583h17.5a.583.583,0,0,1,.583.583Zm0-7A.583.583,0,0,1,22.75,21H5.25a.583.583,0,0,1-.583-.583V19.25a.583.583,0,0,1,.583-.583h17.5a.583.583,0,0,1,.583.583ZM10.5,3.5h7V9.333H21V3.5A3.5,3.5,0,0,0,17.5,0h-7A3.5,3.5,0,0,0,7,3.5V9.333h3.5Z"
        transform="translate(307 470.667)"
        fill="#5a005a"
      />
    </g>
  </svg>
);

export default SVG;
